import Fetch from '../../../mixins/Fetch'
import store from '../../../store/index'

const argsToFormData = (data) => {
  const formData = new FormData()

  const appendInFormData = (arr, fd, arrName) => {
    arr.forEach((el, idx) => {
      fd.append(`${arrName}[${idx}]`, el)
    })
  }

  !data.InitDate || formData.append('InitDate', data.InitDate)
  !data.EndDate || formData.append('EndDate', data.EndDate)
  !data.Service || appendInFormData(data.Service, formData, 'Service')
  !data.BusinessUnit ||
    appendInFormData(data.BusinessUnit, formData, 'BusinessUnit')
  !data.Direction || appendInFormData(data.Direction, formData, 'Direction')

  return formData
}

const defaultReportFilter = async (data, route) => {
  const url = store.getters['Global/getApiBaseUrl']

  const params = {
    initDate: data.initDate,
    endDate: data.endDate,
    service: data.service?.map((a) => a.value),
    businessUnit: data.businessUnit.map((a) => a.value),
    direction: data.direction
  }

  localStorage.setItem('reportFilters', JSON.stringify(data))

  // Deixei o fetch aqui pois por algum motivo estranho o mixin de fetch da erro exclusivamente
  // nessa request por conta do content type estar escrito 'ContentType' e não 'Content-Type'
  // porém nas demais requisições isso não é um problema
  const request = await fetch(`${url}report/${route}`, {
    method: 'POST',
    headers: {
      Authorization: `bearer ${localStorage.getItem('token')}`,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(params)
  }).then((a) => a.json())

  return request
}

const executarPesquisa = async ({ commit }, dados) => {
  const request = Fetch.post('report/getbyboard', dados)

  if (request.status === 'error') throw new Error(request.message)
  return request
}

const executarPesquisaMotivo = async ({ commit }, dados) => {
  const request = Fetch.post('report/reportreasongraphic', dados)

  if (request.status === 'error') throw new Error(request.message)
  return request
}

const fetchBusinessUnitList = async function ({ commit }) {
  const request = await Fetch.get('unit/get')

  if (request.status === 'error') throw new Error(request.message)

  const response = Array.isArray(request) ? request : []

  commit('SETBUSINESSUNITLIST', response)
}

const fetchNpsStatementReport = async ({ commit }, data) => {
  localStorage.setItem('reportFilters', JSON.stringify(data))
  const formData = argsToFormData(data)

  const request = await Fetch.post('report/npsstatement', formData)

  if (request.status === 'error') throw new Error(request.message)

  const response = Array.isArray(request) ? request : []

  commit('SETNPSSTATEMENTREPORT', response)
}

const fetchNpsCountByUnitReport = async ({ commit }, data) => {
  const request = await defaultReportFilter(data, 'npscountbyunit')

  if (request.status === 'error') throw new Error(request.message)

  const response = Array.isArray(request) ? request : []

  commit('SETNPSCOUNTBYUNITREPORT', response)
}

const fetchNpsDetailsReport = async ({ commit }, data) => {
  const formData = argsToFormData(data)

  const request = await Fetch.post('report/npsdetailsreport', formData)

  if (request.status === 'error') throw new Error(request.message)

  const response = Array.isArray(request) ? request : []

  commit('SETNPSDETAILSREPORT', response)
}

const fetchOpHistSolByUnitReport = async ({ commit }, data) => {
  localStorage.setItem('reportFilters', JSON.stringify(data))
  const formData = argsToFormData(data)

  const request = await Fetch.post('report/ophistbyunit', formData)

  if (request.status === 'error') throw new Error(request.message)

  const response = Array.isArray(request) ? request : []

  commit('SETOPHISTSOLBYUNIT', response)
}

const fetchSolicitationByService = async ({ commit }, data) => {
  const formData = argsToFormData(data)
  const request = await Fetch.post('report/solicitationbyservice', formData)

  if (request.status === 'error') throw new Error(request.message)

  const response = Array.isArray(request) ? request : []

  commit('SETSOLICITATIONBYSERVICE', response)
}

const fetchSolicitationyStatus = async ({ commit }, data) => {
  localStorage.setItem('reportFilters', JSON.stringify(data))
  const formData = argsToFormData(data)
  const request = await Fetch.post('report/solicitatiobystatus', formData)

  if (request.status === 'error') throw new Error(request.message)
  console.log(request)

  const response = Array.isArray(request) ? request : []

  commit('SETSOLICITATIONBYSTATUS', response)
}

const fetchLateSolicitations = async ({ commit }, data) => {
  const formData = argsToFormData(data)
  const request = await Fetch.post('report/latesolicitations', formData)

  if (request.status === 'error') throw new Error(request.message)

  const response = Array.isArray(request) ? request : []

  commit('SETLATESOLICITATIONS', response)
}

const extractAllDownload = async ({ commit }) => {
  const request = await Fetch.get('report/extractAllToXlsx')

  if (request.status === 'error') throw new Error(request.message)

  const bytes = request.fileContents
  const mediaType =
    'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,'
  const url = mediaType + bytes
  const a = document.createElement('a')
  a.href = url
  a.download = request.fileDownloadName
  a.click()
  window.URL.revokeObjectURL(url)
  a.remove()

  commit('SETLATESOLICITATIONSDOWNLOAD')
}

const fetchSolicitationsByUserProfile = async ({ commit }, obj) => {
  const formData = new FormData()

  formData.append('DtStart', obj.DtStart)
  formData.append('DtEnd', obj.DtEnd)
  formData.append('Profile', obj.Profile)
  formData.append('BusinessUnit', obj.BusinessUnit || '')

  const request = await Fetch.post('report/solicitationsByUserProfile', formData)

  if (request.status === 'error') throw new Error(request.message)

  const response = Array.isArray(request) ? request : []

  commit('SETSOLICITATIONSBYUSERPROFILE', response)
}

const fetchSolicitationsByUserPerDay = async ({ commit }, obj) => {
  const formData = new FormData()

  formData.append('DtStart', obj.DtStart)
  formData.append('DtEnd', obj.DtEnd)
  formData.append('Profile', obj.Profile)
  formData.append('BusinessUnit', obj.BusinessUnit || '')

  const request = await Fetch.post('report/solicitationsByUserPerDay', formData)

  if (request.status === 'error') throw new Error(request.message)

  const response = Array.isArray(request) ? request : []

  commit('SETBYUSERPERDAY', response)
}

const fetchGeneralTotalSolicitationsPerUser = async ({ commit }, obj) => {
  const formData = new FormData()

  formData.append('DtStart', obj.DtStart)
  formData.append('DtEnd', obj.DtEnd)
  formData.append('Profile', obj.Profile)
  formData.append('BusinessUnit', obj.BusinessUnit || '')

  const request = await Fetch.post('report/generalTotalSolicitationsPerUser', formData)

  if (request.status === 'error') throw new Error(request.message)

  const response = Array.isArray(request) ? request : []

  commit('SETGENERALTOTALSOLICITATIONSPERUSER', response)
}

const fetchAverageSolicitationsPerUser = async ({ commit }, obj) => {
  const formData = new FormData()

  formData.append('DtStart', obj.DtStart)
  formData.append('DtEnd', obj.DtEnd)
  formData.append('Profile', obj.Profile)
  formData.append('BusinessUnit', obj.BusinessUnit || '')

  const request = await Fetch.post('report/averageSolicitationsPerUser', formData)

  if (request.status === 'error') throw new Error(request.message)

  const response = Array.isArray(request) ? request : []

  commit('SETAVERAGESOLICITATIONSPERUSER', response)
}

const fetchTotalNewSolicitationsInDay = async ({ commit }, obj) => {
  const formData = new FormData()

  formData.append('date', obj)

  const request = await Fetch.post('report/totalNewSolicitationsInDay', formData)

  if (request.status === 'error') throw new Error(request.message)

  const response = request

  commit('SETTOTALNEWSOLICITATIONSINDAY', response)
}

const fetchAvarageNewSolicitationsInPeriod = async ({ commit }, obj) => {
  const formData = new FormData()

  formData.append('DtStart', obj.DtStart)
  formData.append('DtEnd', obj.DtEnd)
  formData.append('Profile', obj.Profile)
  formData.append('BusinessUnit', obj.BusinessUnit || '')

  const request = await Fetch.post('report/avarageNewSolicitationsInPeriod', formData)

  if (request.status === 'error') throw new Error(request.message)

  const response = request

  commit('SETAVARAGENEWSOLICITATIONSINPERIOD', response)
}

const fetchApprovedSolicitationsByUnitInPeriod = async ({ commit }, obj) => {
  const formData = new FormData()

  formData.append('DtStart', obj.DtStart)
  formData.append('DtEnd', obj.DtEnd)
  formData.append('Profile', obj.Profile)
  formData.append('BusinessUnit', obj.BusinessUnit || '')

  const request = await Fetch.post('report/approvedSolicitationsByUnit', formData)

  if (request.status === 'error') throw new Error(request.message)

  const response = Array.isArray(request) ? request : []

  commit('SETAPPROVEDSOLICITATIONSBYUNITINPERIOD', response)
}

const fetchTotalUsersByProfile = async ({ commit }) => {
  const request = await Fetch.get('report/totalUsersByProfile')

  if (request.status === 'error') throw new Error(request.message)

  const response = Array.isArray(request) ? request : []

  commit('SETTOTALUSERSBYPROFILE', response)
}

const fetchTotalUsersByUnit = async ({ commit }) => {
  const request = await Fetch.get('report/totalUsersByUnit')

  if (request.status === 'error') throw new Error(request.message)

  const response = Array.isArray(request) ? request : []

  commit('SETTOTALUSERSBYUNIT', response)
}

export default {
  executarPesquisa,
  executarPesquisaMotivo,
  fetchBusinessUnitList,
  fetchNpsStatementReport,
  fetchNpsCountByUnitReport,
  fetchNpsDetailsReport,
  fetchOpHistSolByUnitReport,
  fetchSolicitationByService,
  fetchSolicitationyStatus,
  fetchLateSolicitations,
  extractAllDownload,
  fetchSolicitationsByUserProfile,
  fetchSolicitationsByUserPerDay,
  fetchGeneralTotalSolicitationsPerUser,
  fetchAverageSolicitationsPerUser,
  fetchTotalNewSolicitationsInDay,
  fetchAvarageNewSolicitationsInPeriod,
  fetchApprovedSolicitationsByUnitInPeriod,
  fetchTotalUsersByProfile,
  fetchTotalUsersByUnit
}
